import { API_BASE_URL } from '../../utils/apiConfig';

export function getSiteURL() {
  let url = API_BASE_URL;

  // Make sure to include `http://` or `https://` properly.
  url = url.includes('http') ? url : `https://${url}`;
  // Ensure there is a trailing `/`
  url = url.endsWith('/') ? url : `${url}/`;

  return url;
}
